import React, { Component } from 'react'
import Slider from 'react-slick'

class SliderBanner extends Component {

  render() {
    const { gallery } = this.props

    const settings = {
      fade: true,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      pauseOnHover: false,
      focusOnSelect: false,
    }

    return (
      <>
        <section className='slider-banner' data-color='#FFF'>
          <div className='slider-banner__inner'>
            { gallery?.length > 0 &&
              <Slider {...settings}>
                { gallery.map((el, i) => <img src={el.localFile.publicURL} alt={`Whitefox`} key={i} />) }
              </Slider>
            }
          </div>
        </section>
      </>
    )
  }
}

export default SliderBanner